"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHANGE_BUTTON_TYPES = void 0;
var CHANGE_BUTTON_TYPES;
(function (CHANGE_BUTTON_TYPES) {
    CHANGE_BUTTON_TYPES["FREQUENCY"] = "frequency";
    CHANGE_BUTTON_TYPES["PROTRACK"] = "proTrack";
    CHANGE_BUTTON_TYPES["TEXT_NOTIFICATIONS"] = "textNotifications";
    CHANGE_BUTTON_TYPES["OUT_OF_OFFICE"] = "outOfOffice";
    CHANGE_BUTTON_TYPES["TIME_PREFERENCE"] = "timePreference";
    CHANGE_BUTTON_TYPES["SETTINGS"] = "settings";
    CHANGE_BUTTON_TYPES["SUPPORT"] = "support";
    CHANGE_BUTTON_TYPES["HOME"] = "home";
})(CHANGE_BUTTON_TYPES = exports.CHANGE_BUTTON_TYPES || (exports.CHANGE_BUTTON_TYPES = {}));
//# sourceMappingURL=emails.js.map